/*jshint esversion: 9 */
import React, { Component } from "react";

import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { withStyles } from "@material-ui/core/styles";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Paper from "@material-ui/core/Paper";

import ButtonGroup from "@material-ui/core/ButtonGroup";
import Button from "@material-ui/core/Button";

import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

import { toJS } from "mobx";

import { sha3_512 } from 'js-sha3';

import store from "../../../components/stores/Store";
import {
  deleteUser,
  updateUser,
} from "../../../db/SystemOperationRequestHandler";
import { getIfFuncAuthorized } from "../../../utils/CheckSomething";
import ITextField from "../../../components/UI/ITextField";
import CheckHandler from "../../../utils/CheckHandler";

const styles = {
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
  },
  tableContainer: {
    maxHeight: "450px", // todo
    maxWidth: "100%", // todo
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
};
// TableOfUserManagement
class TableOfUserManagementInner extends Component {
  constructor() {
    super();
    this.state = {
      login: true,
      page: 0,
      rowsPerPage: 10,
      orderBy: "memname",
      order: "asc",
      // update info
      updateDialogOpen: false,
      showPassword: false,
      updateDialogParams: {
        uuid: "",
        orgPhone: "",
        roleName: "",
        phone: "",
        password: "",
        roleTypeID: "",
        remark: "",
      },
      deleteLineDialogOpen: false,
      toDeleteId: '',
    };
    this.sampleMehtod = this.sampleMehtod.bind(this);
    this.createData = this.createData.bind(this);
    this.descendingComparator = this.descendingComparator.bind(this);
    this.getComparator = this.getComparator.bind(this);
    this.stableSort = this.stableSort.bind(this);
    this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);

    this.handleRequestSort = this.handleRequestSort.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);

    this.createSortHandler = this.createSortHandler.bind(this);
    this.deleteLine = this.deleteLine.bind(this);
    this.updateLine = this.updateLine.bind(this);
    this.onDialogChange = this.onDialogChange.bind(this);
    this.closeDeleteLineDialog = this.closeDeleteLineDialog.bind(this);
    this.openDeleteLineDialog  = this.openDeleteLineDialog.bind(this);
  }

  async componentDidMount() { }
  componentWillUnmount() { }

  sampleMehtod(e) {
    console.log(e);
  }

  createData(uid, phone, name, userType) {
    return { uid, phone, name, userType };
  }
  descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => this.descendingComparator(a, b, orderBy)
      : (a, b) => -1 * this.descendingComparator(a, b, orderBy);
  }

  handleOpen(e, num) {
    this.setState({
      openState: {
        ...this.state.openState,
        [num]: !this.state.openState[num],
      },
    });
  }

  handleRequestSort(event, property) {
    const isAsc = this.state.orderBy === property && this.state.order === "asc";
    console.log(`----- handleRequestSort-event: `, event);
    console.log(`----- handleRequestSort-property: `, property);
    this.setState({ order: isAsc ? "desc" : "asc" });
    this.setState({ orderBy: property });
  }

  handleChangePage(event, newPage) {
    console.log(`----- handleChangePage-newPage: `, newPage);
    this.setState({ page: newPage });
  }

  handleChangeRowsPerPage(event) {
    console.log(`----- handleChangeRowsPerPage-event: `, event);
    this.setState({ rowsPerPage: parseInt(event.target.value, 10) });
    this.setState({ page: 0 });
  }

  createSortHandler(event, property) {
    if (property === "action") return;
    console.log(`----- createSortHandler-event: `, event);
    console.log(`----- createSortHandler-property: `, property);
    this.handleRequestSort(event, property);
  }

  closeDeleteLineDialog() {
    this.setState({
      toDeleteId: '',
      deleteLineDialogOpen: false,
    });
  }

  openDeleteLineDialog(e, id) {
    this.setState({
      toDeleteId: id,
      deleteLineDialogOpen: true,
    });
  }

  async deleteLine() {
    const id = this.state.toDeleteId;
    this.closeDeleteLineDialog();
    console.log(`----- send req of deleteUser`);
    const rst = await deleteUser({ ID: id });
    console.log(`----- rst of deleteUser: `, rst);
    if (rst.code === "error") {
      store.openMessageDialogOpen(rst.msg || "系统错误");
      return true;
    } else if (rst.code === "success") {
      console.log(`----- rst: `, rst);
      store.openMessageDialogOpen(rst.msg || "删除成功");
      this.setState({ updateDialogOpen: false });
      store.search();
      return true;
    }
  }

  onDialogChange(e, prop) {
    const newUpdateDialogParams = this.state.updateDialogParams;
    newUpdateDialogParams[prop] = e.target.value;
    e.stopPropagation();
    this.setState({ updateDialogParams: newUpdateDialogParams });
  }

  async updateLine() {
    // todo 按照uuid更新
    const uuid = this.state.updateDialogParams.uuid.trim();
    const orgPhone = this.state.updateDialogParams.orgPhone.trim();
    const phone = this.state.updateDialogParams.phone.trim();
    const roleName = this.state.updateDialogParams.roleName.trim();
    let password = this.state.updateDialogParams.password.trim();
    const roleTypeID = this.state.updateDialogParams.roleTypeID;
    const remark = (this.state.updateDialogParams.remark || '').trim();

    const chkRst = CheckHandler.checkParams([
      {
        key: "原手机号码",
        value: orgPhone,
        notNull: true,
        type: "phone",
        maxLength: 11,
      },
      {
        key: "手机号码",
        value: phone,
        notNull: true,
        type: "phone",
        maxLength: 11,
      },
      {
        key: "用户姓名",
        value: roleName,
        notNull: true,
        type: "",
        maxLength: 20,
      },
      {
        key: "用户密码",
        value: password,
        notNull: false,
        type: "weakPwd",
        maxLength: 20,
      },
      {
        key: "用户类型",
        value: roleTypeID,
        notNull: true,
        type: "",
        maxLength: 64,
      },
      { key: "备注", value: remark, notNull: false, type: "", maxLength: 20 },
    ]);

    if (chkRst.msg) {
      store.openMessageDialogOpen(chkRst.msg);
      return;
    }

    // 密码加密
    if(password) password = sha3_512(password);

    const rst = await updateUser({ uuid, orgPhone, phone, password, roleName, roleTypeID, remark });
    console.log(`----- rst of updateUser: `, rst);
    if (rst.code === "error") {
      store.openMessageDialogOpen(rst.msg || "删除成功");
      return true;
    } else if (rst.code === "success") {
      console.log(`----- rst: `, rst);
      store.openMessageDialogOpen(rst.msg || "删除成功");
      this.setState({ updateDialogOpen: false });
      store.search();
      return true;
    }
  }

  render() {
    const { classes } = this.props;
    const headCells = [
      {
        id: "memname",
        align: "right",
        label: "姓名",
      },
      {
        id: "userid",
        align: "right",
        label: "手机号",
      },
      {
        id: "roletypeid",
        align: "right",
        label: "用户类型",
      },
      {
        id: "action",
        align: "center",
        label: "操作",
      },
    ];

    const emptyRows =
      this.state.rowsPerPage -
      Math.min(
        this.state.rowsPerPage,
        store.table.length - this.state.page * this.state.rowsPerPage
      );

    return (
      <div className={classes.root}>
        <Paper className={classes.paper}>
          <TableContainer>
            <Table
              className={classes.table}
              aria-labelledby="tableTitle"
              size={"small"}
              aria-label="enhanced table"
              id='TableOfUser'
            >
              <TableHead>
                <TableRow>
                  {headCells.map((headCell) => (
                    <TableCell
                      key={headCell.id}
                      align={headCell.align}
                      sortDirection={
                        this.state.orderBy === headCell.id
                          ? this.state.order
                          : false
                      }
                    >
                      {headCell.id !== "action" && (
                        <TableSortLabel
                          active={this.state.orderBy === headCell.id}
                          direction={
                            this.state.orderBy === headCell.id
                              ? this.state.order
                              : "asc"
                          }
                          onClick={(event) =>
                            this.createSortHandler(event, headCell.id)
                          }
                        >
                          {headCell.label}
                          {this.state.orderBy === headCell.id ? (
                            <span className={classes.visuallyHidden}>
                              {this.state.order === "desc"
                                ? "sorted descending"
                                : "sorted ascending"}
                            </span>
                          ) : null}
                        </TableSortLabel>
                      )}

                      {headCell.id === "action" && (
                        <TableSortLabel hideSortIcon>
                          {headCell.label}
                        </TableSortLabel>
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {this.stableSort(
                  store.table,
                  this.getComparator(this.state.order, this.state.orderBy)
                )
                  .slice(
                    this.state.page * this.state.rowsPerPage,
                    this.state.page * this.state.rowsPerPage +
                    this.state.rowsPerPage
                  )
                  .map((row, index) => {
                    let roleName;
                    for (
                      let index = 0;
                      index < store.roleTable.length;
                      index++
                    ) {
                      const element = store.roleTable[index];
                      if (element.ID === row.roletypeid) {
                        roleName = element.rolename;
                        break;
                      }
                    }

                    return (
                      <TableRow hover tabIndex={-1} key={row.UUID} id={row.UUID}>
                        <TableCell
                          component="th"
                          align="right"
                          id={row.memname} 
                          scope="row"
                        >
                          {row.memname}
                        </TableCell>
                        <TableCell id={row.userid} align="right">
                          {row.userid}
                        </TableCell>
                        <TableCell id='userid' align="right">
                          {roleName}
                        </TableCell>
                        <TableCell align="center" style={{ width: '400px' }}>
                          <ButtonGroup
                            variant="contained"
                            aria-label="contained primary button group"
                          >
                            {getIfFuncAuthorized("系统管理-用户管理-修改") && (
                              <Button
                                color="primary"
                                style={{ width: '200px' }}
                                onClick={(e) =>
                                  this.setState({
                                    updateDialogOpen: true,
                                    updateDialogParams: {
                                      orgPhone: row.userid,
                                      uuid: row.UUID,
                                      roleName: row.memname,
                                      phone: row.userid,
                                      password: "",
                                      roleTypeID: row.roletypeid,
                                      remark: row.remark,
                                    },
                                  })
                                }
                              >
                                修改
                              </Button>
                            )}
                            {getIfFuncAuthorized("系统管理-用户管理-删除") && (
                              <Button
                                color="secondary"
                                onClick={(e) => this.openDeleteLineDialog(e, row.UUID)}
                                style={{ width: '200px' }}
                              >
                                删除
                              </Button>
                            )}
                          </ButtonGroup>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 33 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 20, 40]}
            component="div"
            count={store.table.length}
            rowsPerPage={this.state.rowsPerPage}
            page={this.state.page}
            onPageChange={this.handleChangePage}
            onRowsPerPageChange={this.handleChangeRowsPerPage}
          />
        </Paper>



        <Dialog
          aria-labelledby="form-dialog-title"
          open={this.state.updateDialogOpen}
          onClose={(e) => this.setState({ updateDialogOpen: false })}
        >
          <DialogTitle id="form-dialog-title" style={{ width: "300px" }}>
            修改用户
          </DialogTitle>
          <DialogContent>
            <ITextField
              autoFocus
              margin="dense"
              id="name"
              label="手机号码"
              fullWidth
              ivalue={this.state.updateDialogParams.phone}
              onChange={(e) => this.onDialogChange(e, "phone")}
              type="phone"
              maxLength="11"
              notNull
            />
            <ITextField
              margin="dense"
              id="password"
              label="用户密码"
              fullWidth
              ivalue={this.state.updateDialogParams.password}
              onChange={(e) => this.onDialogChange(e, "password")}
              type="weakPwd"
              maxLength="20"
              notNull={false}
            />

            {/* <FormControl>
              <InputLabel htmlFor="standard-adornment-password">用户密码2</InputLabel>
              <Input
                id="standard-adornment-password"
                type={this.state.showPassword ? 'text' : 'password'}
                value={this.state.updateDialogParams.password}
                onChange={(e) => this.onDialogChange(e, "password")}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={ e => this.setState({showPassword: !this.state.showPassword })}
                    >
                      {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl> */}


            {/* <FormControl>
              <ITextField
                margin="dense"
                id="password3"
                label="用户密码3"
                fullWidth
                ivalue={this.state.updateDialogParams.password}
                onChange={(e) => this.onDialogChange(e, "password")}
                type={this.state.showPassword ? 'text' : 'password'}
                maxLength="20"
                notNull={false}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={ e => this.setState({showPassword: !this.state.showPassword })}
                    >
                      {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl> */}
            <ITextField
              margin="dense"
              id="name"
              label="用户姓名"
              fullWidth
              ivalue={this.state.updateDialogParams.roleName}
              onChange={(e) => this.onDialogChange(e, "roleName")}
              type="text"
              maxLength="20"
              notNull
            />
            <FormControl fullWidth style={{ marginTop: "8px" }}>
              <InputLabel
                id="demo-simple-select-outlined-label"
                style={{ marginTop: "-8px" }}
              >
                用户类型
              </InputLabel>
              <Select
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                value={this.state.updateDialogParams.roleTypeID}
                onChange={(e) => this.onDialogChange(e, "roleTypeID")}
                fullWidth
                label="用户类型"
                margin="dense"
              >
                <MenuItem value="">
                  <em>请选择</em>
                </MenuItem>
                {store.roleTable.map((row, index) => {
                  const ID = row.ID;
                  const roleName = row.rolename;
                  return (
                    <MenuItem value={ID} key={ID}>
                      {roleName}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>

            <ITextField
              margin="dense"
              id="name"
              label="备注信息"
              fullWidth
              ivalue={this.state.updateDialogParams.remark}
              onChange={(e) => this.onDialogChange(e, "remark")}
              type="text"
              maxLength="20"
            />
          </DialogContent>
          <DialogActions>
            <Button
              color="primary"
              variant="contained"
              aria-label="contained primary button group"
              onClick={this.updateLine}
            >
              确认修改
            </Button>
            <Button
              onClick={(e) => this.setState({ updateDialogOpen: false })}
              color="primary"
              variant="contained"
              aria-label="contained primary button group"
            >
              取消
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.deleteLineDialogOpen}
          onClose={this.closeDeleteLineDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title" style={{width: '400px'}}>
            {"确认删除？"}
          </DialogTitle>
          <DialogActions>
            <Button onClick={this.deleteLine} color="secondary">
              确认删除
            </Button>
            <Button onClick={this.closeDeleteLineDialog} color="primary" autoFocus>
              取消
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

const TableOfUserManagement = observer(TableOfUserManagementInner);

TableOfUserManagement.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TableOfUserManagement);
